import { Divider, Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { Text, api, getQueryProps, isDefined } from 'common';

import { SubFlowV0Autocomplete } from './SubFlowV0Autocomplete';
import { useFlowDefinitionContext } from '../../../../context';
import { BlockAutocomplete } from '../../ConfigFields/Autocomplete/Autocomplete';
import { ParentBlockSelectField } from '../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';
import { SubFlowPreview } from '../SubFlow/Shared/Preview';

export function HccBlockFormFields() {
  const { flowDefinition } = useFlowDefinitionContext();
  const { data: agentsData } = useQuery({
    ...getQueryProps(api.client.FlowAgent, 'findAll', {
      organizationId: flowDefinition.organizationId,
    }),
  });
  const { field: agentField } = useSelectedNodeField<string>('config.agent');
  const {
    field: flowDefinitionIdField,
    visibleError: flowDefinitionIdVisibleError,
    setValue: setFlowDefinitionId,
  } = useSelectedNodeField<string | undefined>('config.flowDefinitionIds.0');

  return (
    <Stack spacing={2}>
      <BlockAutocomplete
        fieldName="config.agent"
        label="Agent"
        helperText="Pick an existing agent that contains the algorithm subflows"
        options={agentsData?.map((agent) => agent.id) ?? []}
        onChange={() => {
          setFlowDefinitionId(undefined);
        }}
        multiple={false}
        getOptionLabel={(option) => {
          const agent = agentsData?.find((agent) => agent.id === option);
          return agent?.name ?? '';
        }}
      />
      <SubFlowV0Autocomplete
        {...flowDefinitionIdField}
        visibleError={flowDefinitionIdVisibleError}
        setValue={(newValue) => setFlowDefinitionId(newValue)}
        flowDefinitionQueryParams={isDefined(agentField.value) ? { agentId: agentField.value } : {}}
      />
      <Divider />
      <Text variant="heading5" bold>
        Payload
      </Text>
      <ParentBlockSelectField
        fieldName="config.payload.documents.sourceBlockName"
        label="Documents"
        required
      />
      <ParentBlockSelectField
        fieldName="config.payload.problems.sourceBlockName"
        label="Problems"
        required
      />
      <ParentBlockSelectField
        fieldName="config.payload.medications.sourceBlockName"
        label="Medications"
        required
      />
      <ParentBlockSelectField
        fieldName="config.payload.labValues.sourceBlockName"
        label="Lab Values"
        required
      />
      <ParentBlockSelectField
        fieldName="config.payload.procedures.sourceBlockName"
        label="Procedures"
        required
      />
      <SubFlowPreview flowDefinitionId={flowDefinitionIdField.value} />
    </Stack>
  );
}
